import Swiper from 'swiper';

export default function() {

    let itemsSliders = document.getElementsByClassName('js-history-slider');

    Array.from(itemsSliders).forEach(function (slider) {

        let itemsSwiper = new Swiper(slider, {
            loop: false,
            speed: 600,
            spaceBetween: 0,
            slidesPerView: 'auto',
            mousewheel: true
        });
    });

}

